import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-772726b4")

_pushScopeId("data-v-772726b4")
const _hoisted_1 = { class: "card-tag-editor" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex-1 original-tags" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", null, "原始标签:", -1)
const _hoisted_5 = { class: "flex align-baseline" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("strong", null, "文字:")
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("保存文字")
const _hoisted_8 = { class: "flex-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("strong", null, "标签:")
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("添加常用标签")
const _hoisted_12 = { class: "category-name inline-block margin-right-10" }
const _hoisted_13 = { class: "delete-icon inline-block" }
const _hoisted_14 = /*#__PURE__*/_createVNode("i", { class: "icon el-icon-remove" }, null, -1)
const _hoisted_15 = { class: "flex margin-top-20" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createVNode("strong", null, "标签分类:", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_cascader = _resolveComponent("el-cascader")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_el_image, {
        class: "image",
        src: _ctx.card.cardUrl,
        "preview-src-list": [_ctx.card.cardUrl]
      }, null, 8, ["src", "preview-src-list"]),
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.originalImageTags, (tag) => {
          return (_openBlock(), _createBlock(_component_el_tag, { key: tag }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(tag), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode(_component_el_input, {
        class: "text",
        modelValue: _ctx.card.cardText,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.card.cardText = $event))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.saveCardText
      }, {
        default: _withId(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", _hoisted_8, [
      _hoisted_9,
      _hoisted_10,
      (!_ctx.addCardTagCategoryVisible)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "success",
            class: "margin-left-10",
            icon: "el-icon-plus",
            onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.addCardTagCategoryVisible = true; _ctx.categoryIdsToAdd = []})
          }, {
            default: _withId(() => [
              _hoisted_11
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commonCardTagCategories.filter(c => c.tags.length > 0), (category) => {
      return (_openBlock(), _createBlock("div", {
        key: category.tagCategoryId
      }, [
        _createVNode("div", _hoisted_12, [
          _createTextVNode(_toDisplayString(category.tags[0].category.name) + ": ", 1),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_el_popconfirm, {
              class: "block",
              onConfirm: ($event: any) => (_ctx.deleteCommonCardTagCategory(category.tagCategoryId)),
              title: "确定删除常用标签吗？"
            }, {
              reference: _withId(() => [
                _hoisted_14
              ]),
              _: 2
            }, 1032, ["onConfirm"])
          ])
        ]),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(category.tags, (tag) => {
          return (_openBlock(), _createBlock(_component_el_tag, {
            key: tag.id,
            onClick: ($event: any) => (_ctx.clickTag(tag.id)),
            type: _ctx.isSelectedTag(tag.id) ? 'primary' : 'info'
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(tag.name), 1)
            ]),
            _: 2
          }, 1032, ["onClick", "type"]))
        }), 128))
      ]))
    }), 128)),
    _createVNode("div", _hoisted_15, [
      (_ctx.addCardTagCategoryVisible)
        ? (_openBlock(), _createBlock("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_el_cascader, {
              modelValue: _ctx.categoryIdsToAdd,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.categoryIdsToAdd = $event)),
              "show-all-levels": false,
              options: _ctx.tagCategories,
              props: {value: 'id', label: 'name'}
            }, null, 8, ["modelValue", "options"]),
            (_ctx.addCardTagCategoryVisible)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  class: "margin-left-10",
                  onClick: _ctx.addCardTagCategory
                }, {
                  default: _withId(() => [
                    _hoisted_18
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true),
            (_ctx.addCardTagCategoryVisible)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "info",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addCardTagCategoryVisible=false))
                }, {
                  default: _withId(() => [
                    _hoisted_19
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})